export const CHECKOUT_URL =
  'https://mega-pack-sabiduria-divina.impultienda.ar/checkout'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$35.000'

export const BRAND = 'CM Digital Pro™'
export const PRODUCT = 'MEGA PACK SABIDURÍA DIVINA™'
export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/tPA4MXoDjsqjBGDVXZzLKe/Imagen_de_Codex_2_sept_2026,_19_01_19.png'

export const METHOD_FLOW = ['Leer', 'Comprender', 'Reflexionar', 'Aplicar']

export const trustBadges = [
  'Acceso digital inmediato',
  'Pago seguro',
  'Garantía de 7 días',
]

export const audience = [
  'Querés leer la Biblia pero no sabés por dónde empezar.',
  'Hay pasajes que leés pero no terminás de comprender.',
  'Te cuesta entender el contexto, los personajes o las historias.',
  'Querés conocer mejor las enseñanzas de Jesús.',
  'Buscás una forma práctica de aplicar lo que leés.',
  'Querés desarrollar una rutina sencilla sin estudiar durante horas.',
]

export const modules = [
  {
    title: 'La Biblia sin complicaciones™',
    desc: 'Entendé cómo está organizada la Biblia, sus principales libros, etapas, personajes y por dónde comenzar.',
    extra: '',
  },
  {
    title: 'Las grandes historias de la Biblia™',
    desc: 'Descubrí las historias y enseñanzas de Abraham, Moisés, David, Ester, Daniel, Pedro, Pablo y otros personajes fundamentales.',
    extra: '',
  },
  {
    title: 'Las enseñanzas de Jesús™',
    desc: 'Comprendé principios sobre amor, perdón, fe, oración, relaciones, esperanza y propósito.',
    extra: '+ Parábolas explicadas',
  },
  {
    title: 'Promesas y palabras para cada momento™',
    desc: 'Pasajes organizados por temas como miedo, esperanza, decisiones, paciencia, fortaleza y sabiduría.',
    extra: '',
  },
  {
    title: 'Sabiduría bíblica para la vida™',
    desc: 'Principios bíblicos aplicados a familia, relaciones, trabajo, dinero, carácter, decisiones y conflictos.',
    extra: '',
  },
  {
    title: '15 minutos con la Palabra™',
    desc: 'Un método diario para observar, comprender, reflexionar y aplicar lo que leés.',
    extra: '+ Plan guiado de 30 días',
  },
]

export const bonuses = [
  {
    title: '100 Pasajes esenciales™',
    desc: 'Pasajes seleccionados y organizados por temas, acompañados de contexto y una explicación sencilla.',
    value: '$8.000',
  },
  {
    title: 'Mapas y línea del tiempo bíblica™',
    desc: 'Una forma visual de ubicar personajes, lugares y grandes acontecimientos de las Escrituras.',
    value: '$8.000',
  },
  {
    title: 'Diario Sabiduría Divina — 30 días™',
    desc: 'Un espacio para registrar lo que observás, comprendés, reflexionás y aplicás cada día.',
    value: '$7.000',
  },
  {
    title: '30 Oraciones guiadas™',
    desc: 'Oraciones y reflexiones para acompañarte en diferentes momentos de tu vida.',
    value: '$6.000',
  },
  {
    title: 'Diccionario bíblico esencial™',
    desc: 'Conceptos y palabras importantes de las Escrituras explicados de manera clara y sencilla.',
    value: '$6.000',
  },
]

export const method = [
  { time: '3 minutos', title: 'Observa', desc: '¿Qué dice el pasaje?' },
  {
    time: '4 minutos',
    title: 'Comprende',
    desc: '¿Qué significa dentro de su contexto?',
  },
  {
    time: '4 minutos',
    title: 'Reflexiona',
    desc: '¿Qué enseñanza puedo extraer?',
  },
  { time: '4 minutos', title: 'Aplica', desc: '¿Qué puedo llevar conmigo hoy?' },
]

export const includedToday = [
  'MEGA PACK SABIDURÍA DIVINA™',
  '6 módulos digitales',
  'Método 15 Minutos con la Palabra™',
  'Plan Guiado de 30 Días',
]

export const faqs = [
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. Está pensado especialmente para principiantes y personas que quieren comprender mejor lo que leen.',
  },
  {
    q: '¿Cuánto tiempo necesito?',
    a: 'Podés avanzar a tu ritmo. El método principal está diseñado para aproximadamente 15 minutos por sesión.',
  },
  {
    q: '¿Cómo recibo el contenido?',
    a: 'De forma digital después de confirmar tu compra.',
  },
  {
    q: '¿Los 5 bonos tienen costo adicional?',
    a: 'No. Su valor conjunto es de $35.000, pero hoy se incluyen gratis al adquirir MEGA PACK SABIDURÍA DIVINA™.',
  },
  {
    q: '¿Puedo verlo desde mi celular?',
    a: 'Sí. Podés acceder desde celular, tablet o computadora compatible.',
  },
  {
    q: '¿Tengo garantía?',
    a: 'Sí. Contás con 7 días de garantía según las condiciones de compra.',
  },
]
